/**
 * 跨页共享内容 —— Nav / Footer / Brand 等不变量
 */

export const brand = {
  name: 'LoEvent',
  logo: '/images/logo.png',
  tagline: 'AI Agent for in-person events',
  /** 主域名 —— 用于生成绝对 canonical / og:url */
  origin: 'https://loevent.com',
} as const;

/** 全站默认 SEO 兜底值 —— 每页 SEO 缺字段时回退到这里 */
export const defaultSeo = {
  ogImage: `${brand.origin}/images/og-default.png`,
  ogType: 'website' as const,
  twitterHandle: '@loevent',
  /** 全站通用 keywords —— 每页可追加自己的 */
  keywords: [
    'AI event planner',
    'event poster generator',
    'in-person events',
    'web3 events',
    'AI marketing tools',
  ],
};

export const navLinks = [
  { label: 'Pro', href: '/pro' },
  { label: 'Business', href: '/business' },
  { label: 'Connect', href: '/connect' },
] as const;

export const navCta = {
  label: 'Login to Pro',
  href: 'https://app.loevent.com/pro',
} as const;

export const footerColumns = [
  {
    title: 'Product',
    links: [
      { label: 'Pro', href: '/pro' },
      { label: 'Connect', href: '/connect' },
      { label: 'Business', href: '/business' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of Use', href: '/terms' },
      { label: 'Privacy Policy', href: '/privacy' },
    ],
  },
] as const;

export const footerBlurb =
  'One intelligent platform for organizers, attendees, and businesses—from event planning to networking to enterprise execution.';

// ═══════════════════════════════════════════
// JSON-LD helpers —— 生成 schema.org 结构化数据
// 用法：在 page data.ts 的 seo.jsonLd 数组里调用
// ═══════════════════════════════════════════

/** Organization schema（站点级，Home 页用） */
export function organizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: brand.name,
    url: brand.origin,
    logo: `${brand.origin}${brand.logo}`,
    description: brand.tagline,
  };
}

/** WebSite schema（站点级，Home 页用，让 Google 知道是网站） */
export function websiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: brand.name,
    url: brand.origin,
  };
}

/** FAQPage schema —— 自动从 FAQ section data 生成
 *  保证 JSON-LD 跟可见 FAQ 一字不差，避免 Google 罚 deceptive markup */
export function faqJsonLd(items: { q: string; a: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };
}
